module.exports = __webpack_public_path__ + "img/malta.40e69370.svg";